// src/pages/RemoteSensing.jsx
import React from "react";

function RemoteSensing() {
  const containerStyle = {
    maxWidth: "1000px",
    margin: "50px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  };

  const sectionStyle = {
    marginBottom: "40px",
  };

  const headingStyle = {
    color: "#2f6f4e",
    fontSize: "28px",
    marginBottom: "15px",
  };

  const textStyle = {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#333",
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    borderRadius: "10px",
    marginTop: "20px",
  };

  return (
    <div style={containerStyle}>
      {/* Page Title */}
      <h1 style={{ ...headingStyle, textAlign: "center" }}>Remote Sensing</h1>

      {/* Overview Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>Overview</h2>
        <p style={textStyle}>
          Remote Sensing is the science of obtaining information about objects or areas
          from a distance, typically from aircraft or satellites. It allows organizations
          to monitor environmental changes, map land use, manage natural resources, and
          support decision-making with precise geospatial data.
        </p>
        <img
          src="/remote-sensing.jpg"
          alt="Remote Sensing"
          style={imageStyle}
        />
      </div>

      {/* Services Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>Our Remote Sensing Services</h2>
        <ul style={{ ...textStyle, paddingLeft: "20px" }}>
          <li>Satellite Image Acquisition and Analysis</li>
          <li>Land Use and Land Cover Mapping</li>
          <li>Environmental Monitoring</li>
          <li>Disaster Assessment and Management</li>
          <li>Precision Agriculture Analysis</li>
          <li>Change Detection and GIS Integration</li>
        </ul>
      </div>

      {/* Why Choose Us */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>Why Choose GeoFederal?</h2>
        <p style={textStyle}>
          We combine the latest satellite technologies with expert analysis to provide
          accurate and actionable geospatial insights. Our team ensures timely delivery,
          detailed reporting, and customized solutions for every client.
        </p>
      </div>
    </div>
  );
}

export default RemoteSensing;
